<style>
a.google-signin-button {
  width: 47%;
  padding: 10px 0;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  background: #5a646e url(../../../assets/images/google-login.png) no-repeat
    left 15px center;
  display: inline-block;
  width: auto;
  padding-right: 75px;
}
a.google-signin-button {
  position: relative;
  text-align: left;
  padding-left: 90px;
}
a.google-signin-button:before {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  background: #fff;
  top: 0;
  left: 52px;
}
</style>
<template>
  <div>
    <div id="login-container">
      <div class="checkin-area">
        <vs-input
          v-validate="'required|email|min:3'"
          data-vv-validate-on="blur"
          name="email"
          icon-no-border
          label="Email"
          v-model="email"
          class="w-full"
          v-on:keyup.enter="LoginOnEnterKeyPress"
        />
        <div class="user-login-image">
          <img src="../../../assets/images/checkin-images/user-name.svg" />
        </div>
      </div>
      <!-- icon="icon icon-user"
        icon-pack="feather" -->
      <span class="text-danger text-sm">{{ errors.first("email") }}</span>

      <div class="checkin-area">
        <vs-input
          data-vv-validate-on="blur"
          v-validate="'required|min:4'"
          type="password"
          name="password"
          icon-no-border
          label="Password"
          v-model="password"
          class="w-full mt-6"
          v-on:keyup.enter="LoginOnEnterKeyPress"
        />
        <div class="user-login-image">
          <img src="../../../assets/images/checkin-images/password.svg" />
        </div>
      </div>
      <!-- icon="icon icon-lock"
        icon-pack="feather" -->
      <span class="text-danger text-sm">{{ errors.first("password") }}</span>

      <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
          >Remember Me</vs-checkbox
        >
        <a :href="forgotPassLink" v-if="email">Forgot Password</a>


      </div>
      <!--<vs-button type="border" @click="registerUser">Register</vs-button>-->
      <vs-button
        class="w-full"
        :disabled="!validateForm"
        @click="LoginOnEnterKeyPress"
        >Login</vs-button
      >
    </div>
    <!-- <vs-divider>OR</vs-divider> -->
    <div class="social-login-buttons flex flex-wrap items-center mt-4">
      <!-- facebook -->
      <!--<div
        class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
        @click="loginWithFacebook"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="facebook-f"
          class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 264 512"
        >
          <path
            fill="currentColor"
            d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
          />
        </svg>
  </div>-->

      <!-- TWITTER -->
      <!--<div
        class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
        @click="loginWithTwitter"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="twitter"
          class="text-white h-4 w-4 svg-inline--fa fa-twitter fa-w-16"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            fill="currentColor"
            d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
          />
        </svg>
  </div>-->

      <!-- GOOGLE -->
      <div class="pt-0 pl-0 cursor-pointer w-full text-center">
        <div class="sign-in-divider" id="continue-with">
          <p>or continue with</p>
        </div>
        <a
          href="#"
          class="google-signin-button google-login-button"
          v-google-signin-button="clientId"
        >
          Sign In with Google
        </a>
      </div>

      <!-- GITHUB -->
      <!--<div class="bg-github pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithGithub">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="github-alt"
          class="text-white h-4 w-4 svg-inline--fa fa-github-alt fa-w-15"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 480 512"
        >
          <path
            fill="currentColor"
            d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
          />
        </svg>
      </div>-->
    </div>
    <div id="overlay-test" class="login-attendee">
      <div class="attendee-img-hld mx-auto" id="userInitials" v-if="!userImage">
        {{ userInitials }}
      </div>
      <div class="attendee-img-hld mx-auto d-none" id="user-profile-img" v-else>
        <img
          :src="userImage"
          class="imguserthumb"
          v-on:load="loadImage()"
          style="height: 94%; border-radius: 50%"
        />
      </div>

      <div class="welcome-attendee">
        <span class="welcome">Welcome </span>
        <span class="attendee">{{ userFirstName }}!</span>
        <br />
        <span class="attendee-company" v-if="userCompany">
          {{ userCompany }}</span
        >
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import con from "@/firebase/firebaseInit.ts";
import ls from "@/common/localStorage";
import moment from "moment-timezone";
import GoogleSignInButton from "vue-google-signin-button-directive";
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
//var client_collection = "OA_UAT_C1591205467009E1591206650065";
import $ from "jquery";

var vm;
export default {
  directives: {
    GoogleSignInButton,
  },
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      clientId:
        con.Environment == "PRD"
          ? "252698231518-2o68v5tqu1rv1ic5b76jvsgp00reevhn.apps.googleusercontent.com"
          : "119219268154-amccobf15ophtvhaui1h7rkfo222d9eg.apps.googleusercontent.com",
      userImage: "",
      userInitials: null,
      userFirstName: "",
      userCompany: "",
      forgotPassBody: "Hi Support, The admin has requested for a forget password: ",
      forgotPass: "mailto:wstechsupport@webspiders.com?subject=Urgent! Admin has requested for Forget Password&body="

    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== "" && this.password !== "";
    },
    forgotPassLink(){


      return this.forgotPass + this.forgotPassBody + this.email;
    }
  },
  methods: {
    singleEventEnter(obj) {
      var startDate = obj.EventStartDate
        ? moment
            .tz(
              new Date(obj.EventStartDate.seconds * 1000).toUTCString(),
              obj.TimeZone
            )
            .format("MM/DD/YYYY HH:mm")
        : null;
      var endDate = obj.EventEndDate
        ? moment
            .tz(
              new Date(obj.EventEndDate.seconds * 1000).toUTCString(),
              obj.TimeZone
            )
            .format("MM/DD/YYYY HH:mm")
        : null;
      let info = {
        Session_Event_Id: obj.EventId,
        Session_Event_CollectionName: obj.EventCollectionName,
        Session_Event_FullName: obj.EventFullName,
        Session_Event_TZ: obj.TimeZone,
        Session_EventStartDate: startDate,
        Session_EventEndDate: endDate,
        Sesion_StreamingClient: obj.StreamingClient,
        Sesion_EventAccessType: obj.EventAccessType,
        Default_Event_Language: obj.DefaultLanguage,
        Session_LocationType: obj.LocationType.Name,
        UseOnlyGeoCheckinModule: obj.UseOnlyGeoCheckinModule
          ? obj.UseOnlyGeoCheckinModule
          : false,
      };
      ls.setSessionUserInfo(info);
      if (con.GeoCheckinCMS) {
        location.href = "/event/checkin-dashboard";
      } else {
        location.href = "/event/overview";
      }
    },
    OnGoogleAuthSuccess(idToken) {
      // Receive the idToken and make your magic with the backend
      //console.log('login success '+idToken)
      vm.$vs.loading();
      vm.$store
        .dispatch("userManagement/LoginWithToken", {
          token: idToken,
          provider: "Google",
        })
        .then(function (response) {
          vm.$vs.loading.close();
          if (response.status == 200) {
            vm.$router.push(response.redirectTo);
            vm.$vs.notify({
              color: "success",
              position: "top-center",
              //title: "Delete",
              text: "Login Successful",
            });
          } else {
            vm.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Delete",
              text: response.message,
            });
          }
        })
        .catch((err) => {
          vm.$vs.loading.close();
          console.log(err);
          vm.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Delete",
            text: "Something went wrong!",
          });
        });
    },
    OnGoogleAuthFail(error) {
      if (error.error != "popup_closed_by_user") {
        vm.$vs.notify({
          color: "warning",
          position: "top-center",
          //title: "Delete",
          text: "Something went wrong!",
        });
      }

      console.log(error.error);
    },
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        return false;
      }
      return true;
    },
    LoginOnEnterKeyPress() {
      //vm.loginFirestore();
      vm.loginFirestoreAuth();
    },
    loadImage() {
      $("#userInitials").hide();
      $("#user-profile-img").removeClass("d-none");
    },
    loginFirestoreAuth() {
      vm.$vs.loading();
      vm.$store
        .dispatch("userManagement/checFirebaseAuthLogin", {
          email: vm.email,
          password: vm.password,
        })
        .then(function (response) {
          console.log("response===", response);

          vm.$vs.loading.close();
          if (response.status == 200) {
            let userDetail = response.userDetail;
            vm.userImage = userDetail.ProfilePictureURL;
            vm.userInitials = userDetail.Name.split(" ")
              .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
              .join("");
            vm.userFirstName = userDetail.FirstName;
            vm.userCompany = userDetail.Company;
            document.getElementById("login-container").style.display = "none";
            document.getElementById("continue-with").style.display = "none";
            document.getElementById("overlay-test").style.display = "flex";
            debugger;
            vm.$store
              .dispatch(
                "userManagement/firebaseSignInWithCustomToken",
                response.customToken
              )
              .then(function (res) {
                ls.setSessionUserInfo(response.info);
                if (con.GeoCheckinCMS) {
                  if (
                    response.userEvents &&
                    response.userEvents.result &&
                    response.userEvents.result.length == 1
                  ) {
                    if (response.userEvents.result[0].events.length == 1) {
                      vm.singleEventEnter(
                        response.userEvents.result[0].events[0]
                      );
                    } else {
                      vm.$router.push(response.redirectTo);
                    }
                  } else {
                    vm.$router.push(response.redirectTo);
                  }
                } else {
                  vm.$router.push(response.redirectTo);
                }
              })
              .catch((error) => {
                vm.$vs.loading.close();
              });
          } else {
            vm.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Delete",
              text: response.message,
            });
          }
        })
        .catch((err) => {
          vm.$vs.loading.close();
        });
    },
    login() {
      // Loading
      debugger;
      this.$vs.loading();

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
        },
        notify: this.$vs.notify,
        closeAnimation: this.$vs.loading.close,
      };
      this.$store.dispatch("auth/loginAttempt", payload);
    },

    // Google login
    loginWithGoogle() {
      this.$store.dispatch("auth/loginWithGoogle", { notify: this.$vs.notify });
    },

    // Facebook login
    loginWithFacebook() {
      this.$store.dispatch("auth/loginWithFacebook", {
        notify: this.$vs.notify,
      });
    },

    // Twitter login
    loginWithTwitter() {
      this.$store.dispatch("auth/loginWithTwitter", {
        notify: this.$vs.notify,
      });
    },

    // Github login
    loginWithGithub() {
      this.$store.dispatch("auth/loginWithGithub", { notify: this.$vs.notify });
    },
    registerUser() {
      if (!this.checkLogin()) return;
      this.$router.push("/pages/register").catch(() => {});
    },
  },
  created() {
    vm = this;
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }

    if (
      ls.getSessionValueByKey("il") &&
      ls.getSessionValueByKey("Session_AccessToken")
    ) {
      vm.$vs.loading();
      vm.$store.dispatch("userManagement/checkTokenExpiry").then((idToken) => {
        vm.$vs.loading.close();
        if (ls.getSessionValueByKey("Role") == 1) {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            icon: "close",
            title: "Welcome",
            text: "You are signed in",
          });
          vm.$router.push("/client/list");
        } else {
          if (ls.getSessionValueByKey("UseOnlyGeoCheckinModule")) {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              icon: "close",
              title: "Welcome",
              text: "You are signed in",
            });
            if (con.GeoCheckinCMS) {
              vm.$router.push("/event/checkin-dashboard");
            } else {
              vm.$router.push("/event/overview");
            }
          } else {
            this.$vs.notify({
              color: "success",
              position: "top-center",
              icon: "close",
              title: "Welcome",
              text: "You are signed in",
            });
            vm.$router.push("/event/list");
          }
        }
      });
    }
  },
};
</script>

<style>
#overlay-test {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 2;
  cursor: pointer;
}
.welcome-attendee {
  text-align: center;
}
.login-attendee {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login-attendee .attendee-img-hld {
  width: 132px;
  height: 132px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 54px;
  text-transform: uppercase;
  border: 1px solid #f2f2f2;
  background-color: #ebeff2;
  color: #6d6f7b;
}
.login-attendee .attendee {
  color: rgb(28, 29, 38);
  font-size: 24px;
  font-weight: 500;
}
.login-attendee .welcome {
  font-size: 24px;
  padding-right: 5px;
}
.login-attendee .attendee-company {
  color: rgb(28, 29, 38);
  font-size: 19px;
  font-weight: 500;
}
</style>
<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
